import { Box } from '@mui/material';
import { LoaderContainer } from './LoaderContainer';

type Props = {
  isLoading: boolean;
  isFetchingNextPage: boolean;
  hasNextPage?: boolean;
  lastElementRef: (node: HTMLElement | null) => void;
  noEndPadding?: boolean;
  LoaderProps?: { size?: number };
};

const styles = {
  endPadding: {
    py: { xs: 4, md: 6 },
  },
  triggerBox: {
    height: 56,
  },
};

const InfiniteScrollLoader = ({
  isLoading,
  isFetchingNextPage,
  hasNextPage,
  lastElementRef,
  noEndPadding,
  LoaderProps,
}: Props) => {
  if (isFetchingNextPage) {
    return <LoaderContainer {...LoaderProps} />;
  }

  if (!isLoading && hasNextPage) {
    return <Box sx={styles.triggerBox} ref={lastElementRef} />;
  }

  if (!isLoading && !hasNextPage && !noEndPadding) {
    return <Box sx={styles.endPadding} />;
  }

  return null;
};

export default InfiniteScrollLoader;
